/* eslint-disable react-hooks/exhaustive-deps */
import { Grid, Tab, Tabs } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CustomIcon from 'commons/Icon/CustomIcon';
import LocalizedText from 'commons/LocalizedText/LocalizedText';
import { ManageContact } from 'components/Administration/ManageContact';
import { ManageGeneral } from 'components/Administration/ManageGeneral';
import { PageContainer } from 'components/PageContainer/PageContainer';
import SkeletonLaboratoryCard from 'components/Skeletons/SkeletonLaboratoryCard/SkeletonLaboratoryCard';
import useQueryState from 'hook/UseQueryState';
import { useUserInfo } from 'hook/UseUserInfo';
import React, { Suspense, useCallback, useEffect } from 'react';
import { ParamTypes } from 'utils/constants/param.type';
import { MOBILE_BREAKPOINT } from 'utils/constants/responsive';
import { isSuperAdmin } from 'utils/constants/roles';
import { GET_ADMINSTRATION_TABS } from 'utils/constants/tabs';
import { QueryStringToJSONObject } from 'utils/helpers/QueryStringHelper';
import { GENERATE_ROUTE, ROUTES } from 'utils/constants/routes';
import { ErrorName } from 'utils/constants/error.name';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  marginTop: {
    marginTop: theme.spacing(3),
    [theme.breakpoints.down(MOBILE_BREAKPOINT)]: {
      marginTop: theme.spacing(1)
    }
  },
  divider: {
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down(MOBILE_BREAKPOINT)]: {
      marginBottom: theme.spacing(1)
    }
  },
  tabs: {
    maxWidth: '50%',
    marginBottom: '10px'
  },
  tab: {
    minHeight: 67,
    minWidth: 50,
    padding: '3px 10px',
    fontSize: '112%',
    color: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.primary.menuHover
    },
    '& .MuiTab-wrapper > *:first-child': {
      marginBottom: 3
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '95%'
    }
  }
}));

export const AdministrationPage = () => {
  const classes = useStyles();
  const history = useHistory();
  const { role } = useUserInfo();
  const [tabSelected, setTabSelected] = useQueryState(
    'tabSelected',
    QueryStringToJSONObject(window.location.search.substring(1)).tabSelected || 0,
    ParamTypes.NUMBER
  );
  const adminTabs = GET_ADMINSTRATION_TABS();

  const handleChangeTab = useCallback((_, tab) => setTabSelected(tab), []);

  useEffect(() => {
    if (!isSuperAdmin(role)) {
      history.push(GENERATE_ROUTE(ROUTES.ERROR), { errorMessage: ErrorName.UNAUTHORIZED_ACTION });
    }
  },[role])

  return (
    <PageContainer>
      {
        isSuperAdmin(role)
        && (
          <>
            <Grid container direction="column" spacing={4}>
              <Grid item>
                <Tabs
                  centered
                  className={classes.tabs}
                  indicatorColor="secondary"
                  onChange={handleChangeTab}
                  textColor="secondary"
                  value={tabSelected}
                  variant="fullWidth"
                >
                  {adminTabs.map((currentTab) => (
                    <Tab
                      classes={{
                        root: classes.tab
                      }}
                      icon={<CustomIcon icon={currentTab.ICON} size="lg"/>}
                      key={currentTab.LABEL}
                      label={<LocalizedText className="bold" text={(currentTab.LABEL)}/>}
                    />
                  ))}
                </Tabs>

                <Suspense fallback={SkeletonLaboratoryCard()}>
                  {[
                    <ManageGeneral/>,
                    <ManageContact/>
                  ][tabSelected]}
                </Suspense>
              </Grid>
            </Grid>
          </>
        )
      }
    </PageContainer>
  );
};